import {observer} from "mobx-react";
import {
    FmsCreatePage,
    FmsOverviewPage,
    FmsPackageDetailPage,
    FmsPicklistDetailPage,
    FmsShippingClientCreatePage,
    FmsShippingClientDetailPage,
    FmsShippingManagementPage,
    FmsTabType
} from "../page/fms";
import {App} from "./App";

type FmsAppMode = 'create' | 'overview' | 'detail'
    | 'package-detail' | 'picklist-detail' | 'shipping-client'
    | 'create-shipping-client' | 'detail-shipping-client'
    | 'shipping-client-config'

interface FmsAppProps {
    mode: FmsAppMode
    tab?: FmsTabType
}

const FmsApp = observer(function FmsApp({mode, tab}: FmsAppProps) {
    return <App>
        {mode === 'overview' && <FmsOverviewPage tab={tab}/>}
        {mode === 'create' && <FmsCreatePage/>}
        {mode === 'package-detail' && <FmsPackageDetailPage/>}
        {mode === 'picklist-detail' && <FmsPicklistDetailPage/>}
        {mode === 'shipping-client' && <FmsShippingManagementPage />}
        {mode === 'shipping-client-config' && <FmsShippingManagementPage tab={'config'} />}
        {mode === 'create-shipping-client' && <FmsShippingClientCreatePage/>}
        {mode === 'detail-shipping-client' && <FmsShippingClientDetailPage/>}
    </App>
})

export {
    FmsApp
}
